import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

// Animates a string value like "1,200", "45%", "12+" by counting the numeric part.
export default function AnimatedNumber({ value }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [display, setDisplay] = useState(String(value));

  useEffect(() => {
    if (!inView) return;
    const m = String(value).match(/^([^0-9]*)([0-9][0-9,.]*)(.*)$/);
    if (!m) { setDisplay(String(value)); return; }
    const prefix = m[1];
    const numStr = m[2].replace(/,/g, "");
    const suffix = m[3];
    const hadComma = m[2].includes(",");
    const decimals = (numStr.split(".")[1] || "").length;
    const target = parseFloat(numStr);
    if (Number.isNaN(target)) { setDisplay(String(value)); return; }

    let start = null;
    const dur = 1500;
    let raf;
    const step = (t) => {
      if (start === null) start = t;
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      const cur = target * eased;
      let s = decimals ? cur.toFixed(decimals) : Math.round(cur).toString();
      if (hadComma) s = Number(s).toLocaleString("en-IN");
      setDisplay(prefix + s + suffix);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  return <span ref={ref}>{display}</span>;
}
